import { createBlockMulti } from "@/api/geometry/block";
import { addFont, findFontGlyphs } from "@/api/geometry/font";
import { createPrimitiveMulti } from "@/api/geometry/primitive";
import { saveUcs } from "@/api/geometry/ucs";
import axios from "axios";
import { AddLayerCommand, AxisT, BlockT, DcalignedT, Layer, Line, ModelUtils, Point, font, ttf } from "pytha";
import { Vector3 } from "three";
import localStore from "../store/local-store";
import { graphicStore } from "../store/graphic-store";
import { saveLayer } from "@/api/geometry/layer";


export default class DxfToEntityUtil {
    layer: Layer;
    font: font;
    projectUuid: string;
    modelUuid: string;
    branchUuid: string

    ttfList: ttf[] = [{ name: "Times New Roman", style: "常规", unicodeFile: "times.ttf", bakFile: "stsong.ttf", unicodeRange: "0000-077F", source: "system" }];
    currentFont: font = { name: "standard", factor: 1.0, originFont: false, fontname: "Times New Roman", style: "常规" };
    Viewer = (dxf, newfile) => {
        return new Promise((resolve, reject) => {
            let layers = [];
            let fontStyles = [];
            let objs = [];
            let textFont = {};
            let textFontData = {};
            let blockTextFont = {};
            let blockTextFontData = {};
            let blocks = [];
            //异步任务列表
            let promiseList = [];
            //图层
            let myLayers = graphicStore?.context?.layerContext?.layers || []
            for (let key of Object.keys(dxf.tables.layer.layers)) {
                let item = dxf.tables.layer.layers[key];
                let name = "_" + item.name
                if (myLayers.find(item => item.name == name)) {
                    layers.push(myLayers.find(item => item.name == name))
                } else {
                    let uuid = ModelUtils.generateUUID();
                    let newLayer: Layer = {
                        ...this.layer,
                        uuid: uuid,
                        name: "_" + item.name,
                        color: '#' + (Array(6).join('0') + item.color.toString(16)).slice(-6),
                        lock: item.frozen,
                        lineWidth: item.lineWidth === -3 ? 0.25 : item.lineWidth / 100,
                        originLayer: false
                    };
                    layers.push(newLayer);
                    graphicStore.context.layerContext.addLayer(newLayer)
                    promiseList.push(saveLayer(newLayer, this.projectUuid, this.modelUuid, this.branchUuid));
                }
            }

            this.loadPromiseList(promiseList).then(_ => {
                promiseList = [];
                let currentFont = graphicStore.extraContext.fontContext.state.currentFont
                fontStyles.push({ ...currentFont, fontname: currentFont.ttf.name, name: "_" + currentFont.name.toLowerCase() })
                return 1;
            }).then(() => {
                let params = {
                    unicodeFile: "times.ttf",
                    rangeStart: 0,
                    rangeEnd: 1919,
                    bakFile: "stsong.ttf",
                    text: '0123456789. \\:;/*=+-_abcdefghigklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
                }
                findFontGlyphs(params).then(res => {
                    graphicStore.extraContext.fontContext.setDimFontData(res.data);
                    promiseList = [];
                    //UCS
                    if (dxf.tables.ucs.ucses != null) {
                        for (let key of Object.keys(dxf.tables.ucs.ucses)) {
                            let item = dxf.tables.ucs.ucses[key];
                            let uuid = ModelUtils.generateUUID();
                            let axisX = new Vector3(item.axisX.x, item.axisX.y, item.axisX.z);
                            let axisY = new Vector3(item.axisY.x, item.axisY.y, item.axisY.z);
                            let axisZ = axisX.clone().cross(axisY.clone());
                            let newUcs = {
                                uuid: uuid, name: item.name, origin: { x: item.origin.x, y: item.origin.y, z: item.origin.z }, axisX: { x: item.axisX.x, y: item.axisX.y, z: item.axisX.z },
                                axisY: { x: item.axisY.x, y: item.axisY.y, z: item.axisY.z }, axisZ: { x: axisZ.x, y: axisZ.y, z: axisZ.z }
                            };
                            promiseList.push(saveUcs(newUcs, this.projectUuid, this.modelUuid, this.branchUuid));
                        }
                    }
                    return this.loadPromiseList(promiseList);
                })
            }).then(_ => {
                promiseList = [];
                // //块文字合并 blockTextFont: { (key: string): string }
                // for (let blockName of Object.keys(dxf.blocks)) {
                //     let block = dxf.blocks[blockName];
                //     this.mergeBlockText(block, fontStyles, blockTextFont)
                // }
                // for (let key of Object.keys(blockTextFont)) {
                //     let fontStyle = fontStyles[0]
                //     let params = { ...graphicStore.extraContext.fontContext.findCurrentTtf(fontStyle.ttf), text: blockTextFont[key] };
                //     promiseList.push(findFontGlyphs(params));
                // }
                axios.all(promiseList).then(res => {
                    // for (let i = 0; i < Object.keys(blockTextFont).length; i++) {
                    //     blockTextFontData[Object.keys(blockTextFont)[i]] = res[i].data;
                    // }
                    //获取内部块的图元
                    for (let blockName of Object.keys(dxf.blocks)) {
                        let block = dxf.blocks[blockName];
                        if (block.entities) {
                            dxf.blocks[blockName] = this.getBlockEntitis(block, dxf.blocks);
                        }
                    }
                    //创建块模型
                    for (let blockName of Object.keys(dxf.blocks)) {
                        let block = dxf.blocks[blockName];
                        let newBlock = this.drawBlock(block, dxf, layers, fontStyles, blockTextFontData);
                        if (newBlock) {
                            blocks.push(newBlock);
                        }
                    }
                    // createBlockMulti(blocks).then(_ => {
                    promiseList = [];
                    // //文字合并 textFont: { (key: string): string }
                    // for (let entity of dxf.entities) {
                    //     if (entity.type === 'TEXT') {
                    //         this.mergeText(entity, fontStyles, textFont)
                    //     }
                    // }
                    // let text = ""
                    // for (let key in blockTextFont) {
                    //     text += blockTextFont[key]
                    // }
                    // for (let key in textFont) {
                    //     text += textFont[key]
                    // }
                    // let fontStyle = fontStyles[0]
                    // let params = { ...graphicStore.extraContext.fontContext.findCurrentTtf(fontStyle.ttf), text: text };
                    // promiseList.push(findFontGlyphs(params));
                    axios.all(promiseList).then(res => {
                        // // return
                        // for (let i = 0; i < Object.keys(textFont).length; i++) {
                        //     textFontData[Object.keys(textFont)[i]] = res[i].data;
                        // }
                        //图元
                        for (let entity of dxf.entities) {
                            let obj = this.drawEntity(entity, dxf, layers, fontStyles, textFontData, blocks);
                            if (obj) {
                                objs.push(obj);
                            }
                        }
                        createPrimitiveMulti(objs, {
                            modelUuid: this.modelUuid,
                            projectUuid: this.projectUuid,
                        }).then(res => { resolve(1) }).catch(err => { reject(err) });
                    })
                    // })
                })
            })
        })
    }

    drawEntity = (entity, data, layers, fontStyles, textFontData, blocks = []) => {
        if (entity.type === 'CIRCLE' || entity.type === 'ARC') {
            return this.drawArc(entity, data, layers);
        } else if (entity.type === 'LINE') {
            return this.drawLine(entity, data, layers);
        } else if (entity.type === 'LWPOLYLINE' || entity.type === 'POLYLINE') {
            return this.drawPline(entity, data, layers);
        } else if (entity.type === 'TEXT') {
            // return this.drawText(entity, data, layers, fontStyles, textFontData);
        } else if (entity.type === 'POINT') {
            return this.drawPoint(entity, data, layers);
        } else if (entity.type === 'INSERT') {
            return this.drawInsert(entity, data, layers, blocks);
        } else if (entity.type === 'DIMENSION') {
            return this.drawDimension(entity, data, layers);
        } else {
            return console.log("Unsupported Entity Type: " + entity.type);
        }
    }

    drawArc = (entity, data, layers) => {
        if (entity.layer == null) entity.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        if (entity.type === 'CIRCLE') {
            let normalX = entity.normal ? entity.normal.x : 0;
            let normalY = entity.normal ? entity.normal.y : 0;
            let normalZ = entity.normal ? entity.normal.z : 1;
            let normal = new Vector3(normalX, normalY, normalZ);
            let axis: AxisT = new AxisT();
            axis.origin.copy(new Vector3(0, 0, 0));
            axis.axisZ.copy(normal);
            if (Math.abs(normal.x) < 1 / 64 && Math.abs(normal.y) < 1 / 64) {
                axis.axisX.copy(new Vector3(0, 1, 0).cross(normal).normalize());
            } else {
                axis.axisX.copy(new Vector3(0, 0, 1).cross(normal).normalize());
            }
            axis.axisY.copy(normal).cross(axis.axisX).normalize();
            let center = axis.axisX.clone().multiplyScalar(entity.center.x).add(axis.axisY.clone().multiplyScalar(entity.center.y).add(axis.axisZ.clone().multiplyScalar(entity.center.z)));
            let circle = {
                uuid: ModelUtils.generateUUID(),
                center: {
                    x: center.x,
                    y: center.y,
                    z: center.z,
                },
                radius: entity.radius,
                aClockWise: false,
                normal: {
                    x: normalX,
                    y: normalY,
                    z: normalZ,
                },
                axisX: {
                    x: axis.axisX.x,
                    y: axis.axisX.y,
                    z: axis.axisX.z,
                },
                color: this.getColor(entity, data),
                lineWidth: entity.lineWidth === -3 ? 0.25 : entity.lineWidth / 100,
                isLineWidthByLayer: entity.lineWidth ? false : true,
                type: 'CircleT',
                isColorByLayer: false,
                graphicUuid: this.projectUuid,
                layerUuid: layer.uuid,
            }
            return circle;
        } else if (entity.type === 'ARC') {
            let normalX = entity.normal ? entity.normal.x : 0;
            let normalY = entity.normal ? entity.normal.y : 0;
            let normalZ = entity.normal ? entity.normal.z : 1;
            let normal = new Vector3(normalX, normalY, normalZ);
            let axis: AxisT = new AxisT();
            axis.origin.copy(new Vector3(0, 0, 0));
            axis.axisZ.copy(normal);
            if (Math.abs(normal.x) < 1 / 64 && Math.abs(normal.y) < 1 / 64) {
                axis.axisX.copy(new Vector3(0, 1, 0).cross(normal).normalize());
            } else {
                axis.axisX.copy(new Vector3(0, 0, 1).cross(normal).normalize());
            }
            axis.axisY.copy(normal).cross(axis.axisX).normalize();
            let center = axis.axisX.clone().multiplyScalar(entity.center.x).add(axis.axisY.clone().multiplyScalar(entity.center.y).add(axis.axisZ.clone().multiplyScalar(entity.center.z)));
            let arc = {
                uuid: ModelUtils.generateUUID(),
                center: {
                    x: center.x,
                    y: center.y,
                    z: center.z,
                },
                radius: entity.radius,
                startAngle: entity.startAngle,
                endAngle: entity.endAngle,
                aClockWise: false,
                normal: {
                    x: normalX,
                    y: normalY,
                    z: normalZ,
                },
                axisX: {
                    x: axis.axisX.x,
                    y: axis.axisX.y,
                    z: axis.axisX.z,
                },
                color: this.getColor(entity, data),
                lineWidth: entity.lineWidth === -3 ? 0.25 : entity.lineWidth / 100,
                isLineWidthByLayer: entity.lineWidth ? false : true,
                type: 'ArcT',
                isColorByLayer: false,
                graphicUuid: this.projectUuid,
                layerUuid: layer.uuid,
            }
            return arc;
        }
    }

    drawLine = (entity, data, layers) => {
        if (!entity.vertices) return console.log('entity missing vertices.');
        if (entity.layer == null) entity.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        let line = {
            uuid: ModelUtils.generateUUID(),
            start: {
                x: entity.vertices[0].x,
                y: entity.vertices[0].y,
                z: entity.vertices[0].z,
            },
            end: {
                x: entity.vertices[1].x,
                y: entity.vertices[1].y,
                z: entity.vertices[1].z,
            },
            color: this.getColor(entity, data),
            lineWidth: entity.lineWidth === -3 ? 0.25 : entity.lineWidth / 100,
            isLineWidthByLayer: entity.lineWidth ? false : true,
            type: 'LineT',
            isColorByLayer: false,
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
        }
        return line;
    }

    drawPline(entity, data, layers) {
        if (entity.layer == null) entity.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        let normalX = entity.extrusionDirectionX || 0;
        let normalY = entity.extrusionDirectionY || 0;
        let normalZ = entity.extrusionDirectionZ !== undefined ? entity.extrusionDirectionZ : 1;
        let normal = new Vector3(normalX, normalY, normalZ);
        let axis: AxisT = new AxisT();
        axis.origin.copy(new Vector3(0, 0, 0));
        axis.axisZ.copy(normal);
        if (Math.abs(normal.x) < 1 / 64 && Math.abs(normal.y) < 1 / 64) {
            axis.axisX.copy(new Vector3(0, 1, 0).cross(normal).normalize());
        } else {
            axis.axisX.copy(new Vector3(0, 0, 1).cross(normal).normalize());
        }
        axis.axisY.copy(normal).cross(axis.axisX).normalize();
        let elevation = entity.elevation || 0;
        let pline = {
            uuid: ModelUtils.generateUUID(),
            pointList: entity.vertices.map((point) => {
                let targetPoint = axis.axisX.clone().multiplyScalar(point.x).add(axis.axisY.clone().multiplyScalar(point.y)).add(axis.axisZ.clone().multiplyScalar(elevation));
                return {
                    x: targetPoint.x,
                    y: targetPoint.y,
                    z: targetPoint.z,
                }
            }),
            normal: {
                x: normalX,
                y: normalY,
                z: normalZ,
            },
            axisX: {
                x: axis.axisX.x,
                y: axis.axisX.y,
                z: axis.axisX.z,
            },
            elevation: elevation,
            loop: entity.shape,
            color: this.getColor(entity, data),
            lineWidth: entity.lineWidth === -3 ? 0.25 : entity.lineWidth / 100,
            isLineWidthByLayer: entity.lineWidth ? false : true,
            type: 'PlineT',
            isColorByLayer: false,
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            plineAttributes: entity.vertices.map((point) => {
                return {
                    startWidth: point.startWidth || 0,
                    endWidth: point.endWidth || 0,
                    bulge: point.bulge || 0,
                }
            }),
        }
        return pline;
    }

    drawText = (entity, data, layers, fontStyles, textFontData) => {
        if (entity.layer == null) entity.layer = 0;
        let normalX = entity.normal ? entity.normal.x : 0;
        let normalY = entity.normal ? entity.normal.y : 0;
        let normalZ = entity.normal ? entity.normal.z : 1;
        let normal = new Vector3(normalX, normalY, normalZ);
        let axis: AxisT = new AxisT();
        axis.origin.copy(new Vector3(0, 0, 0));
        axis.axisZ.copy(normal);
        if (Math.abs(normal.x) < 1 / 64 && Math.abs(normal.y) < 1 / 64) {
            axis.axisX.copy(new Vector3(0, 1, 0).cross(normal).normalize());
        } else {
            axis.axisX.copy(new Vector3(0, 0, 1).cross(normal).normalize());
        }
        axis.axisY.copy(normal).cross(axis.axisX).normalize();
        let position = axis.axisX.clone().multiplyScalar(entity.startPoint.x).add(axis.axisY.clone().multiplyScalar(entity.startPoint.y).add(axis.axisZ.clone().multiplyScalar(entity.startPoint.z)));
        let axisX = graphicStore.context.ucsContext.getAxisxByAngle(normal, entity.rotation);
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        if (entity.stylename == null) entity.stylename = "standard";
        // let fontStyle = fontStyles.find(fontStyle => fontStyle.name === "_" + entity.stylename.toLowerCase());
        let fontStyle = fontStyles[0]

        let fontData = textFontData[fontStyle.uuid];
        if (!fontData) {
            return null
        }
        let newFontData = { ...fontData, glyphs: {} };
        for (let str of entity.text) {
            if (!fontData.glyphs[str]) {
                continue;
            }
            newFontData.glyphs[str] = fontData.glyphs[str];
        }
        if(Object.keys(newFontData.glyphs).length == 0){
            return
        }
        let text = {
            uuid: ModelUtils.generateUUID(),
            text: entity.text,
            position: {
                x: position.x,
                y: position.y,
                z: position.z,
            },
            size: entity.textHeight,
            normal: {
                x: normalX,
                y: normalY,
                z: normalZ,
            },
            axisX: {
                x: axisX.x,
                y: axisX.y,
                z: axisX.z,
            },
            color: this.getColor(entity, data),
            lineWidth: entity.lineWidth === -3 ? 0.25 : entity.lineWidth / 100,
            isLineWidthByLayer: entity.lineWidth ? false : true,
            type: 'DTextT',
            isColorByLayer: false,
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            fontUuid: fontStyle.uuid,
            fontData: newFontData,
        }
        return text;
    }

    drawPoint(entity, data, layers) {
        if (entity.layer == null) entity.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        let point = {
            uuid: ModelUtils.generateUUID(),
            position: {
                x: entity.position.x,
                y: entity.position.y,
                z: entity.position.z,
            },
            normal: {
                x: entity.extrusionDirection ? entity.extrusionDirection.x : 0,
                y: entity.extrusionDirection ? entity.extrusionDirection.y : 0,
                z: entity.extrusionDirection ? entity.extrusionDirection.z : 1,
            },
            color: this.getColor(entity, data),
            type: 'PointT',
            isColorByLayer: false,
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            pointType: 1,
        }
        return point
    }

    drawBlock(block, data, layers, fontStyles, blockTextFontData) {
        let blockEntities = [];
        //块模型图层
        if (block.layer == null) block.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + block.layer);
        //迭代创建块模型
        if (block.entities == null) {
            return this.makeBlock(block, blockEntities, layer);
        }
        if (!block.entities.some(entity => entity.type === 'INSERT')) {
            for (let entity of block.entities) {
                let obj = this.drawEntity(entity, data, layers, fontStyles, blockTextFontData);
                blockEntities.push(obj);
            }
            return this.makeBlock(block, blockEntities, layer);
        } else {
            for (let entity of block.entities) {
                if (entity.type === 'INSERT') {
                    let newBlock = this.drawBlock(entity, data, layers, fontStyles, blockTextFontData);
                    blockEntities.push(newBlock);
                } else {
                    let obj = this.drawEntity(entity, data, layers, fontStyles, blockTextFontData);
                    blockEntities.push(obj);
                }
            }
            return this.makeBlock(block, blockEntities, layer);
        }
    }

    makeBlock(block, blockEntities, layer) {
        let entities = blockEntities.map(element => element);
        let newBlock = {
            uuid: ModelUtils.generateUUID(),
            type: 'BlockT',
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            name: block.name,
            position: {
                x: block.position.x,
                y: block.position.y,
                z: block.position.z,
            },
            normal: {
                x: 0,
                y: 0,
                z: 1,
            },
            axisX: {
                x: 1,
                y: 0,
                z: 0,
            },
            scaleRatio: 1,
            entities: entities,
        }
        return newBlock
    }

    drawInsert(insert, data, layers, blocks) {
        if (insert.layer == null) insert.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + insert.layer);
        let blockModel = new BlockT();
        let blockModelJson = blocks.find(block => block.name === insert.name);
        //块的基点
        let position = new Vector3(insert.position.x, insert.position.y, insert.position.z);
        let point = new Point(insert.position.x, insert.position.y, insert.position.z);
        //块的法向量
        let normal = new Vector3(insert.extrusionDirection ? insert.extrusionDirection.x : 0, insert.extrusionDirection ? insert.extrusionDirection.y : 0, insert.extrusionDirection ? insert.extrusionDirection.z : 1);
        //块的水平向量
        let axisX = graphicStore.context.ucsContext.getAxisxByAngle(normal, insert.rotation ? insert.rotation : 0);
        if (blockModelJson && blockModelJson.entities.length != 0) {
            blockModel.fromJson(blockModelJson, true);
            // 根据块图元insert和块模型blockModel的normal，axisX和scaleRatio，将块模型进行移动、旋转、缩放变换至块图元位置
            insert.entities = blockModel.getEntities();
            // 移动insert基点
            let moveDir = position.clone().sub(blockModel.position);
            insert.entities.forEach(entity => entity.move(moveDir.clone().normalize(), moveDir.length()));
            //旋转轴及角度
            let normalRotateAxis = normal.clone().cross(blockModel.normal).normalize();
            if (Math.abs(normal.dot(blockModel.normal) + 1) < 1e-6) {
                normalRotateAxis = axisX.clone();
            }
            let normalDeltaAngle = blockModel.normal.angleTo(normal);
            // 绕normal1 × normal2，旋转normal1-normal2角度，即旋转到块图元insert所在的normal方向
            insert.entities.forEach(entity => entity.rotate(point, normalRotateAxis, normalDeltaAngle));
            let tempAxisX = blockModel.axisX.clone().applyAxisAngle(normalRotateAxis, normalDeltaAngle);
            let axisXRotateAxis = tempAxisX.clone().cross(axisX).normalize();
            let axisXDeltaAngle = tempAxisX.angleTo(axisX);
            if (Math.abs(tempAxisX.dot(axisX) + 1) < 1e-6) {
                axisXRotateAxis = insert.normal.clone();
            }
            // 绕tempAxisX × axisX2，旋转tempAxisX-axisX2角度，即旋转到块图元insert所在的axisX方向
            insert.entities.forEach(entity => entity.rotate(point, axisXRotateAxis, axisXDeltaAngle));
            // 按缩放比例缩放entities
            insert.entities.forEach(entity => entity.scale(position, insert.scaleRatio ? insert.scaleRatio : 1 / blockModel.scaleRatio));
        } else {
            insert.entities = [];
        }
        let newBlock = {
            uuid: ModelUtils.generateUUID(),
            type: 'BlockT',
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            name: insert.name,
            position: {
                x: insert.position.x,
                y: insert.position.y,
                z: insert.position.z,
            },
            normal: {
                x: normal.x,
                y: normal.y,
                z: normal.z,
            },
            axisX: {
                x: axisX.x,
                y: axisX.y,
                z: axisX.z,
            },
            scaleRatio: insert.xScale,
            entities: insert.entities.map(entity => entity.toJson()),
        }
        return newBlock
    }

    drawDimension(entity, data, layers) {
        if (entity.layer == null) entity.layer = 0;
        let layer = layers.find(layer => layer.name === "_" + entity.layer);
        //标注左下角
        let leftFoot = new Vector3(entity.linearOrAngularPoint1?.x, entity.linearOrAngularPoint1?.y, entity.linearOrAngularPoint1?.z);
        //标注右下角
        let rightFoot = new Vector3(entity.linearOrAngularPoint2?.x, entity.linearOrAngularPoint2?.y, entity.linearOrAngularPoint2?.z);
        if (leftFoot.equals(rightFoot)) return;
        let type = 'DcalignedT';
        switch (entity.dimensionType) {
            case 129:
                type = 'DcalignedT';
                break;
            default:
                console.log("Unsupported Dimension Type: " + entity.dimensionType);
                return;
        }
        let text = leftFoot.distanceTo(rightFoot).toString();
        let name = '';
        if (entity.text != null) {
            name = entity.text.split("=")[0];
            text = entity.text.split("=")[1];
        }
        //位于尺寸线上的点centerHead
        let centerHead = new Point(entity.anchorPoint?.x, entity.anchorPoint?.y, entity.anchorPoint?.z);
        //由leftFoot和rightFoot构造的线
        let footLine = new Line(leftFoot, rightFoot);
        //centerHead在footLine上的投影点
        let centerFoot = new Point();
        footLine.closestPointToPoint(centerHead, false, centerFoot);
        //centerFoot和centerHead构造的线的向量
        let direction = new Vector3(centerHead.x - centerFoot.x, centerHead.y - centerFoot.y, centerHead.z - centerFoot.z);
        //标注的法向量
        let normal = new Vector3(entity.extrusionDirection ? entity.extrusionDirection.x : 0, entity.extrusionDirection ? entity.extrusionDirection.y : 0, entity.extrusionDirection ? entity.extrusionDirection.z : 1);
        let entities = [];

        if (type === 'DclinearT') {
            let dcaligned = new DcalignedT(leftFoot, rightFoot, direction, normal);
            dcaligned.content = text;
            dcaligned.textHeight = leftFoot.distanceTo(rightFoot) * 0.1;
            dcaligned.arrowSize = leftFoot.distanceTo(rightFoot) * 0.1;
            dcaligned.arrowWidth = dcaligned.arrowSize / 6;
            dcaligned.generateEntities();
            entities = dcaligned.getEntities();
        }

        let dimension = {
            uuid: ModelUtils.generateUUID(),
            color: this.getColor(entity, data),
            type: type,
            isColorByLayer: false,
            graphicUuid: this.projectUuid,
            layerUuid: layer.uuid,
            name: name,
            leftFoot: {
                x: entity.linearOrAngularPoint1.x,
                y: entity.linearOrAngularPoint1.y,
                z: entity.linearOrAngularPoint1.z,
            },
            rightFoot: {
                x: entity.linearOrAngularPoint2.x,
                y: entity.linearOrAngularPoint2.y,
                z: entity.linearOrAngularPoint2.z,
            },
            direction: {
                x: direction.x,
                y: direction.y,
                z: direction.z,
            },
            normal: {
                x: entity.extrusionDirection ? entity.extrusionDirection.x : 0,
                y: entity.extrusionDirection ? entity.extrusionDirection.y : 0,
                z: entity.extrusionDirection ? entity.extrusionDirection.z : 1,
            },
            entities: entities.map(item => item.toJson())
        }
        return dimension;
    }

    loadPromiseList = (promiseList) => {
        return new Promise((resolve, reject) => {
            let master: Promise<any>[] = [];
            if (promiseList.length === 0) {
                resolve(1);
                return;
            }
            master[0] = promiseList[0];
            for (var i = 1; i < promiseList.length; i++) {
                if (master[i - 1] == null) {
                    reject(0);
                    return;
                }
                master[i] = master[i - 1].then((res => {
                    return promiseList[i];
                })).catch(err => {
                    return null;
                });
            }
            if (master[i - 1] != null) {
                master[i - 1].then(res => {
                    resolve(1);
                })
            }
        })
    }

    mergeText = (entity, fontStyles, textFont) => {
        if (entity.stylename == null) entity.stylename = "standard";
        // let fontStyle = fontStyles.find(fontStyle => fontStyle.name === "_" + entity.stylename.toLowerCase());
        // if (!fontStyle) {
        let fontStyle = fontStyles[0]
        // }
        if (Object.keys(textFont).includes(fontStyle.uuid)) {
            textFont[fontStyle.uuid] = textFont[fontStyle.uuid] + entity.text;
        } else {
            textFont[fontStyle.uuid] = entity.text;
        }
        return textFont
    }

    mergeBlockText = (block, fontStyles, blockTextFont) => {
        if (block.entities == null) return;
        if (!block.entities.some(entity => entity.type === 'INSERT')) {
            for (let entity of block.entities) {
                if (entity.type === 'TEXT') {
                    this.mergeText(entity, fontStyles, blockTextFont);
                    return;
                }
            }
        } else {
            for (let entity of block.entities) {
                if (entity.type === 'INSERT') {
                    this.mergeBlockText(entity, fontStyles, blockTextFont);
                } else if (entity.type === 'TEXT') {
                    this.mergeText(entity, fontStyles, blockTextFont);
                }
            }
            return blockTextFont;
        }
    }

    //若块中包含块，获取被包含的块的图元
    getBlockEntitis(block, blocks) {
        let key = Object.keys(blocks).find(key => block.name === key);
        block.entities = blocks[key].entities;
        if (!block.entities.some(entity => entity.type === 'INSERT')) {
            return block;
        } else {
            for (let i = 0; i < block.entities.length; i++) {
                if (block.entities[i].type === 'INSERT') {
                    let newBlock = this.getBlockEntitis(block.entities[i], blocks);
                    block.entities.splice(i, 1);
                    block.entities.push(newBlock);
                }
            }
            return block;
        }
    }

    getColor = (entity, data) => {
        var color = '000000'; //default
        if (entity.color) color = (Array(6).join('0') + entity.color.toString(16)).slice(-6);
        else if (data.tables && data.tables.layer && data.tables.layer.layers[entity.layer])
            color = (Array(6).join('0') + data.tables.layer.layers[entity.layer].color.toString(16)).slice(-6);
        let colorstr = '#' + color;
        return colorstr;
    }
}